import React, {useEffect, useState} from "react";
import {Alert, Box, Stack, Text} from "@mantine/core";
import {IconAlertTriangle} from "@tabler/icons-react";
import {formatBuildInfo, getFrontendBuildInfo} from "@/common/utils/buildInfo.ts";
import {loadServerBuildInfo} from "@/common/services/versionService.ts";
import classes from "./SoftwarePanel.module.css";

const BuildInfoLines: React.FC<{ lines: string[] }> = ({lines}) => (
    <>
        {lines.map((line) => (
            <Text key={line} size="sm" c="dimmed">{line}</Text>
        ))}
    </>
);

export interface AboutPanelProps {
}

export const AboutPanel: React.FC<AboutPanelProps> = () => {
    const frontendLines = formatBuildInfo(getFrontendBuildInfo());
    const [serverLines, setServerLines] = useState<string[] | null>(null);

    useEffect(() => {
        loadServerBuildInfo()
            .then((info) => setServerLines(formatBuildInfo(info)))
            .catch((e) => console.error("Failed to load server version", e));
    }, []);

    // frontend and backend ship in the same image, so a mismatch normally means a stale page
    const mismatch = serverLines !== null && serverLines.join("\n") !== frontendLines.join("\n");

    return (
        <Box className={classes.root}>
            <Stack gap="md">
                <Box className={classes.card}>
                    <Box className={classes.cardHeader}>
                        <Text fw={600} size="lg">Neurotune</Text>
                        <BuildInfoLines lines={frontendLines}/>
                    </Box>
                    {mismatch && (
                        <Alert color="yellow" icon={<IconAlertTriangle/>} title="Server is running a different build">
                            <BuildInfoLines lines={serverLines}/>
                            <Text size="sm" mt="xs">Reload the page to update.</Text>
                        </Alert>
                    )}
                    <Text size="xs" c="dimmed" mt="md">Copyright (c) 2025-2026 BIOS Health</Text>
                </Box>
            </Stack>
        </Box>
    );
};
